<template>
  <div class="ivan-setting-page anCore-fill" v-loading="loading">
    <div class="row">
      <div class="form-group col-sm-4 has-feedback">
        <div class="input-group">
          <span class="input-group-addon"><span>监测类型</span></span>
          <select class="form-control" v-model="typeFilter">
            <option value="">全部</option>
            <option v-for="t in typeOptions" :key="t" :value="t">{{ t }}</option>
          </select>
        </div>
      </div>
    </div>

    <div class="table-area">
      <table class="table table-bordered">
        <thead>
          <tr>
            <th style="min-width:120px;">监测类型</th>
            <th style="min-width:120px;">模板名称</th>
            <th style="min-width:150px;">模板文件</th>
            <th style="min-width:75px;">序号</th>
            <th style="width:110px;text-align:center;">
              <button type="button" class="btn btn-success btn-sm" @click="onReadonly">
                <i class="fa fa-plus" />&nbsp;新增
              </button>
            </th>
          </tr>
        </thead>
        <tbody v-if="filtered.length">
          <tr
            v-for="(row, idx) in filtered"
            :key="row.ID || idx"
            :class="{ 'anCore-item-active': selectedId === (row.ID || idx) }"
            @click="selectRow(row.ID || idx)"
          >
            <td>{{ row.MonitorCategory }}</td>
            <td>{{ row.ItemType }}</td>
            <td>
              <a href="javascript:void(0);" @click.prevent.stop="onReadonly">{{ row.Template }}</a>
            </td>
            <td>{{ empty(row.SortNo) }}</td>
            <td>
              <button type="button" class="btn btn-link btn-sm" title="编辑" @click.stop="onReadonly">
                <i class="fa fa-edit" />
              </button>
              <button type="button" class="btn btn-link btn-sm" title="删除" @click.stop="onReadonly">
                <i class="fa fa-trash-o text-muted" />
              </button>
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="5">
              <div class="text-center text-muted" style="padding:10px 0;">当前暂无数据</div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { loadIvanSyncJson } from '@/utils/ivanSync'
import ivanSettingList from '@/mixins/ivanSettingList'

export default {
  name: 'ReportTplSetting',
  mixins: [ivanSettingList],
  data() {
    return {
      loading: false,
      list: [],
      typeOptions: [],
      typeFilter: ''
    }
  },
  computed: {
    filtered() {
      if (!this.typeFilter) return this.list
      return this.list.filter(r => r.MonitorCategory === this.typeFilter)
    }
  },
  created() {
    this.load()
  },
  methods: {
    empty(v) {
      return v == null ? '' : v
    },
    async load() {
      this.loading = true
      try {
        const data = await loadIvanSyncJson('report_tpl.json')
        this.list = (data && data.dataGrid && data.dataGrid.List) || []
        this.typeOptions = data.projectTypeList || []
        if (!this.typeOptions.length) {
          const set = {}
          this.list.forEach(r => {
            if (r.MonitorCategory) set[r.MonitorCategory] = true
          })
          this.typeOptions = Object.keys(set)
        }
      } catch (e) {
        this.$message.error(e.message || '加载报告模板失败')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.ivan-setting-page {
  height: 100%;
  padding: 8px 12px 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.ivan-setting-page > .row { margin: 0; flex: 0 0 auto; }
.table-area {
  flex: 1 1 auto;
  min-height: 0;
  overflow: auto;
  height: calc(100% - 60px);
}
.table-area >>> tbody tr { cursor: pointer; }
</style>
